import { Flow_0_0_2 } from '@flexus/core';

export const MulAgentDashboard: Flow_0_0_2 = {
    id: 'agent_dashboard',
    name: 'agent dashboard',
    startNode: 'AgentDashboard',
    itemType: 'flow',
    instructions: {
        editRoles: {
            0: 'Placeholder'
        },
        viewRoles: {
            0: 'Placeholder'
        }
    },
    header: {
        title: 'Agent Mini Dashboard',
        controls: () => () => []
    },
    footer: {
        type: 'node_nav'
    },
    nodes: {
        AgentDashboard: {
            name: 'Agent Mini Dashboard',
            component: 'AgentMiniDashboardComponent'
        },
    }
}
